<template>
  <v-card elevation="3">
    <v-card-text>
      <v-row class="text-left">
        <v-col cols="12" class="text-left">
          <div class="margin-global text-h6 text-medium-emphasis font-weight-regular">
            Nome do plano: {{ nomePlano }}
          </div>
          <div class="margin-global text-h6 text-medium-emphasis font-weight-regular">
            Status do plano: {{ statusPlano }}
          </div>
          <div class="margin-global text-h6 text-medium-emphasis font-weight-regular">
            Valor total: {{ valorTotal | currency }}
          </div>
          <div class="margin-global text-h6 text-medium-emphasis font-weight-regular">
            Validade:
            <v-chip v-if="validade" color="green" variant="flat">
              Válido
            </v-chip>
            <v-chip v-else variant="flat">
              Inconsistente
            </v-chip>
          </div>      
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
  
  <script>
  export default {
    props: {
      nomePlano: String,
      statusPlano: String,
      valorTotal: Number,
      validade: null,
    },
  };
  </script>
  